export default __webpack_public_path__ + "media/images/fonts/materialdesignicons-webfont-ed840d794dc7ea1c6a53363d73f72509.eot";